//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import CRUDGenerico from '../../../../shared-components/generico/CRUDGenerico';
import ImportacaoLateral from './SellOutLateral';
import ConteudoSellOutConsolidado from './SelloutTabelaConsolidado';
import ConteudoSellOutDetalhado from './SelloutTabelaDetalhado';

import { generateComputed } from '../../../../common/functions/roles-computed-generator';

export default {
  name: 'SellOut',
  extends: CRUDGenerico,
  data() {
    return {
      tabelaDetalhadoAtiva: false,
      consolidado: null,
      sellOutResources: this.$api.sellOut(this.$resource),
      tableHeaderConsolidado: [
        {
          name: this.$t('label.competencia'),
          tooltip: this.$t('label.competencia'),
          sortType: 'competencia',
          classes: [],
        },
        {
          name: this.$t('label.distribuidor'),
          tooltip: this.$t('label.distribuidor'),
          sortType: 'distribuidor',
          classes: ['md-hide-medium'],
        },
        {
          name: this.$t('label.cnpj_cliente'),
          tooltip: this.$t('label.cnpj_cliente'),
          sortType: 'cnpjcliente',
          classes: [],
        },
        {
          name: this.$tc('label.cliente', 1),
          tooltip: this.$tc('label.cliente', 1),
          sortType: 'nomecliente',
          classes: [],
        },
        {
          name: this.$t('label.quantidade'),
          tooltip: this.$t('label.quantidade'),
          sortType: 'quantidadeprodutos',
          classes: ['md-hide-medium'],
        },
        {
          name: this.$t('label.valor_total'),
          tooltip: this.$tc('label.valor', 1),
          sortType: 'valortotal',
          classes: ['md-hide-medium'],
        },

      ],
      tableRowsConsolidado: [],
      tableHeaderDetalhado: [
        {
          name: this.$t('label.competencia'),
          tooltip: this.$t('label.competencia'),
          sortType: 'competencia',
          classes: [],
        },
        {
          name: this.$t('label.numero_nf'),
          tooltip: this.$t('label.numero_nota_fiscal'),
          sortType: 'numeronotafiscal',
          classes: [],
        },
        {
          name: this.$t('label.cnpj_distribuidor'),
          tooltip: this.$t('label.cnpj_distribuidor'),
          sortType: 'cnpjdistribuidor',
          classes: [],
        },
        {
          name: this.$t('label.distribuidor'),
          tooltip: this.$t('label.distribuidor'),
          sortType: 'distribuidor',
          classes: [],
        },
        {
          name: this.$t('label.cnpj_loja'),
          tooltip: this.$t('label.cnpj_loja'),
          sortType: 'cnpjloja',
          classes: [],
        },
        {
          name: this.$tc('label.ean', 1),
          tooltip: this.$tc('label.ean', 1),
          sortType: 'ean',
          classes: [],
        },
        {
          name: this.$tc('label.produto', 1),
          tooltip: this.$tc('label.produto', 1),
          sortType: 'nomeproduto',
          classes: [],
        },
        {
          name: this.$t('label.un_medida'),
          tooltip: this.$t('label.unidade_medida'),
          sortType: 'unidademedida',
          classes: ['md-hide-medium'],
        },
        {
          name: this.$t('label.qtd'),
          tooltip: this.$t('label.quantidade_produto'),
          sortType: 'quantidadeproduto',
          classes: ['md-hide-medium'],
        },
        {
          name: this.$t('label.valor_unitario'),
          tooltip: this.$t('label.valor_unitario'),
          sortType: 'valorunitario',
          classes: ['md-hide-medium'],
        },
        {
          name: this.$t('label.valor_total'),
          tooltip: this.$t('label.valor_total'),
          sortType: 'valortotal',
          classes: [],
        },
        {
          name: this.$t('label.valor_liquido'),
          tooltip: this.$t('label.valor_liquido'),
          sortType: 'valorliquido',
          classes: ['md-hide-medium'],
        },
      ],
      tableRowsDetalhado: [],
    };
  },
  computed: {
    ...generateComputed('Sellout', [
      'canImport',
      'canExport',
    ]),
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el.startsWith('SELLOUT')).length;
    },
  },
  components: {
    ConteudoSellOutConsolidado,
    ConteudoSellOutDetalhado,
    ImportacaoLateral,
  },
  methods: {
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create('Acesso negado', 'snack', 3E3);
      }
    },
    organizarConsolidado(ordenacao) {
      this.organizar(ordenacao, this.tableRowsConsolidado);
    },
    organizarDetalhado(ordenacao) {
      this.organizar(ordenacao, this.tableRowsDetalhado);
    },
    requestExportacao(cb) {
      if (!this.canExport) {
        return;
      }
      this.exportar(cb, 'sellout_simples');
    },
    cleanTableNoResultConsolidado(cb) {
      this.tableRowsConsolidado = [];
      if (cb) {
        cb();
      }
    },
    requestPopularConsolidado(page = null, cb = null, source = null) {
      this.tabelaDetalhadoAtiva = false;
      this.consolidado = null;
      const pagination = page || { size: 20, page: 1 };

      this.sellOutResources.listarConsolidado(pagination)
        .then((response) => {
          const objetos = response.data.resposta;

          if (!objetos.length) {
            if (pagination.page < 2) {
              this.cleanTableNoResultConsolidado(cb);
            } else if (cb) {
              cb(true);
            }
            return;
          }

          if (objetos && objetos.hasOwnProperty('length') && objetos.length) {
            if (pagination.page < 2) {
              if (source) {
                source = [];
                source.push(...objetos);
              } else {
                this.tableRowsConsolidado = [];
                this.tableRowsConsolidado.push(...objetos);
              }
            } else {
              (source || this.tableRowsConsolidado).push(...objetos);
            }
          }
          if (cb) {
            cb();
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    requestPopularDetalhado({ idcliente, competencia, numeronotafiscal }, filter = null) {
      this.sellOutResources.listarDetalhado({
        nota: numeronotafiscal,
        competencia,
        idcliente,
        filter,
      })
        .then((response) => {
          const objetos = response.data;
          this.tableRowsDetalhado = [];

          if (objetos && objetos.hasOwnProperty('length') && objetos.length) {
            this.tableRowsDetalhado.push(...objetos);
            if (!this.tabelaDetalhadoAtiva) {
              this.tabelaDetalhadoAtiva = true;
            }
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    detalharConsolidado(consolidado) {
      this.consolidado = consolidado;
      this.tableRowsDetalhado = [];
      this.tabelaDetalhadoAtiva = false;
      this.requestPopularDetalhado(consolidado);
    },
    detalhadoBusca(filter) {
      this.requestPopularDetalhado(this.consolidado, filter);
    },
    exibirTabConsolidado() {
      this.tabelaDetalhadoAtiva = false;
    },
  },
  mounted() {
    if (!this.canAccessPage) {
      window.setTimeout(() => this.accessForbidden(), 1E3);
    }
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/sell-out/SellOut.vue?vue&type=script&lang=js&